import { render, staticRenderFns } from "./CrLegalEntityDetails.vue?vue&type=template&id=61420b92&lang=pug"
import script from "./CrLegalEntityDetails.vue?vue&type=script&lang=ts"
export * from "./CrLegalEntityDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports